import { useEffect, useRef, useState } from "react";

export function useContainerDimensions<T extends HTMLElement>(
  externalRef?: React.RefObject<T>
) {
  const internalRef = useRef<T>(null);
  const ref = externalRef ?? internalRef;

  const [width, setWidth] = useState<number>(0);

  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect) {
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
      }
    });

    observer.observe(node);

    setWidth(node.getBoundingClientRect().width);

    return () => observer.disconnect();
  }, []);

  return { ref, width, height };
}

export default useContainerDimensions;
